module.exports = __webpack_public_path__ + "img/SEJ enventos_sede.eaa9908d.svg";